<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimButceHarcamalariTutarlari from "@/models/StrBirimButceHarcamalariTutarlari";
import AddEdit from "./AddEdit.vue";
export default {
  mixins: [Api, Sabit, StrBirimButceHarcamalariTutarlari],
  props: ["ButceHarcamalariId"],
  components: {
    AddEdit,
  },
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: [],
      DataUpdate: "",
      AddEdit: "",
    };
  },

  methods: {
    Get() {
      let Filter = "&Birimbutceharcamalariid=" + this.ButceHarcamalariId;
      this.ActionsFilterGet({Service:"StrBirimButceHarcamalariTutarlari",Page:this.Page,Filter:Filter}).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.$emit("TableUpdate");
      });
    },
  },
  created(){
    let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsGet({"Service":"StrHesapKodlari", "Page":Page}).then((res) => {
        this.StrHesapKodlari = res.Data;
      });
  }
};
</script>

<template>
  <div> 
    <div class="card-body">
      <div class="row">
        <div class="col-10"><h4 class="card-title">{{$t('StrBirimButceHarcamalariTutarlari.Title')}}</h4></div>
        <div class="col-2">
          <i
            v-b-modal.StrBirimButceHarcamalariTutarlari
            @click="
              (DataUpdate = StrBirimButceHarcamalariTutarlariData),
                (AddEdit = 'Add'),
                (StrBirimButceHarcamalariTutarlariData.Birimbutceharcamalariid =
                  ButceHarcamalariId)
            "
            class="fas fa-plus"
            >{{$t('StrBirimButceHarcamalariTutarlari.Page.YeniKayitEkle')}}
          </i>
        </div> 
      </div>

      <p class="card-title-desc"></p>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>{{$t('StrBirimButceHarcamalariTutarlari.Table.HesapKodAciklama')}}</th>
              <th>{{$t('StrBirimButceHarcamalariTutarlari.Table.Kdvsiz')}}</th>
              <th>{{$t('StrBirimButceHarcamalariTutarlari.Table.Kdv')}}</th>
              <th>{{$t('StrBirimButceHarcamalariTutarlari.Table.Tutar')}}</th>
              <th>{{$t('StrBirimButceHarcamalariTutarlari.Table.Islem')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="TableDataTutarlarVerileri in TableData"
              :key="TableDataTutarlarVerileri.Id"
            >
              <th scope="row">
                {{ TableDataTutarlarVerileri.HesapKodAciklama }}
              </th>
              <td>{{ TableDataTutarlarVerileri.Kdvsiz }}</td>
              <td>{{ TableDataTutarlarVerileri.Kdv }}</td>
              <td>{{ TableDataTutarlarVerileri.Tutar }}</td>
              <td>
                <div class="w-100 d-flex justify-content-center align-center items-center justify-content-between">
                  <!--
                      <i
                      class="fas fa-pencil-alt"
                      v-b-modal.StrBirimButceHarcamalariTutarlari
                      @click="
                        (DataUpdate = TableDataTutarlarVerileri), (AddEdit = 'Edit')
                      "
                       >   
                      </i>
                  -->
                &nbsp;
                <i
                  class="fas fa-trash-alt"
                  @click="
                    Delete(
                      'StrBirimButceHarcamalariTutarlari',
                      TableDataTutarlarVerileri.Id
                    )
                  "
                ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br />

        <b-pagination
          class="pagination pagination-rounded justify-content-end mb-2"
          v-model="DefaultPage"
          :total-rows="Page.PageDataSize"
          :per-page="Page.PageSize"
          aria-controls="my-table"
          @input="ChangePage(DefaultPage)"
        >
        </b-pagination>
      </div>
    </div>

    <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()" />
  </div>
</template>
